export const GETTER_LIST_REWARD_ERROR_LOG = "GETTER_LIST_REWARD_ERROR_LOG";
export const GETTER_LIST_REWARD_ERROR_LOG_PAGINATION =
  "GETTER_LIST_REWARD_ERROR_LOG_PAGINATION";

export const ACTION_GET_LIST_REWARD_ERROR_LOG =
  "ACTION_GET_LIST_REWARD_ERROR_LOG";

export const MUTATION_SET_LIST_REWARD_ERROR_LOG =
  "MUTATION_SET_LIST_REWARD_ERROR_LOG";

export const REWARD_ERROR_STATUS = {
  NEW: "New",
  RESOLVING: "Resolving",
  RESOLVED: "Resolved"
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_rewards_error/constants.js